import React from 'react';

class PendingReviews extends React.Component {
    render() {
        return (
            <div>PENDING REVIEWS</div>
        );
    }
}

export default PendingReviews;



/** WEBPACK FOOTER **
 ** ./src/components/PendingReviews/PendingReviews.js
 **/